import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { safeReturnUrl } from "../lib/safeReturnUrl";
import AccessDenied from "../pages/AccessDenied";

// Route guard implementing TAVEN routing governance:
//   - unauthenticated protected route -> redirect to /login with an ALLOWLISTED internal returnUrl
//   - authenticated but unauthorized (missing role) -> 403 branded Access Denied
//   - otherwise render the protected element
// (Retired resources -> 410 RetiredOffering; unknown routes -> 404 NotFound are handled in App.js.)
export default function ProtectedRoute({ children, roles }) {
  const { user, token, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center" data-testid="route-guard-loading">
        <Loader2 className="w-6 h-6 animate-spin text-taven-gold" />
      </div>
    );
  }

  if (!token || !user) {
    const returnUrl = safeReturnUrl(location.pathname + location.search, "/account");
    return (
      <Navigate
        to={`/login?returnUrl=${encodeURIComponent(returnUrl)}`}
        replace
        state={{ from: returnUrl }}
      />
    );
  }

  if (roles && roles.length) {
    const userRoles = Array.isArray(user.roles) ? user.roles : [];
    const allowed = userRoles.some((r) => roles.includes(r));
    if (!allowed) return <AccessDenied />;
  }

  return children;
}
